<template>
  <div>
    <DataTable
      api="/admin/devices"
      :on-row-selected-callback="onDeviceSelected"
    />
  </div>
</template>

<script>
import DataTable from '@core/components/data-table/DataTable.vue'

export default {
  components: {
    DataTable,
  },
  data() {
    return {
    }
  },
  methods: {
    onDeviceSelected(row) {
      this.$router.push(`/accounts/${row[0].email}/devices/${row[0].id}`)
    },
  },
}
</script>
